import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import scrollTo from './helpers/scroll-to'

class RouteChange extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  }

  componentDidUpdate (prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged(this.props)
    }
  }

  onRouteChanged (props) {
    scrollTo({
      to: 0,
      duration: 200,
    })

    if (!this.animate) {
      document.body.classList.add('page-transition')
      this.animate = true
    } else {
      clearTimeout(this.pageTransitionTimeout)
    }

    this.pageTransitionTimeout = setTimeout(() => {
      document.body.classList.remove('page-transition')
      this.animate = false
    }, 1500)
  }

  render () {
    return null
  }
}

export default withRouter(RouteChange)



// WEBPACK FOOTER //
// ./src/RouteChange.js